document.addEventListener('DOMContentLoaded', () => {
  let burgerMenu = document.querySelector('.burger-menu');
  var navBar = document.querySelector('.nav-bar');
  if (burgerMenu) {
    burgerMenu.addEventListener('click', () => {
      burgerMenu.classList.toggle('active');
      navBar.classList.toggle('toggle');
      document.body.classList.toggle('lock');
    })
  }
})
